import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

import { MainLayout, Container, AppContent } from 'components/Layout';
import Header from 'components/Header';
import Tracker from 'components/Tracker';
import Footer from 'components/Footer';
import { useConfig } from 'config/ConfigContext';

import Routes from './Routes';
import './App.scss';

export const App = () => {
  const { pageSenseId } = useConfig();
  const isIframe = window.self !== window.top;
  const applicationId = useSelector((state) => get(state, 'workflow.attributes.entityId'));

  const addPageSenseScript = () => {
    if (document.querySelector(`script[src*="pagesense"]`)) {
      return;
    }
    const scriptTag = document.createElement('script');
    scriptTag.src = `https://cdn.pagesense.io/js/lendingusa/${pageSenseId}.js`;
    document.head.appendChild(scriptTag);
  };

  useEffect(() => {
    if (pageSenseId) {
      addPageSenseScript();
    }
  }, [pageSenseId]);

  useEffect(() => {
    if (!applicationId) return;

    window.dataLayer = window.dataLayer || [];
    const existing = window.dataLayer.find((entry) => entry.applicationId);

    if (existing) {
      existing.applicationId = applicationId;
    } else {
      window.dataLayer.push({ applicationId });
    }
  }, [applicationId]);

  return (
    <MainLayout>
      {!isIframe && <Header />}
      <AppContent>
        {!isIframe && <Tracker />}
        <Container>
          <Routes />
          {!isIframe && <Footer />}
        </Container>
      </AppContent>
    </MainLayout>
  );
};

export default App;
